
/**
 * --- External Imports ---
 */
import { useMemo } from "react";
import { SWRConfiguration, SWRResponse } from "swr";

/**
 * --- Internal Imports ---
 */
import { GetMasterGroupsByTrialId, GetMasterGroupsByTrialIdResponse } from "@/apis/dtos";
import useGet from "../apis/useGet";

/**
 * --- Hook ---
 */
const getData = (response?: SWRResponse<GetMasterGroupsByTrialIdResponse, GetMasterGroupsByTrialIdResponse>) => response?.data?.masterGroups;
const getError = (response?: SWRResponse<GetMasterGroupsByTrialIdResponse, GetMasterGroupsByTrialIdResponse>) => (response?.error ?? response?.data)?.responseStatus;
const getAdditionalState = (_?: SWRResponse<GetMasterGroupsByTrialIdResponse, GetMasterGroupsByTrialIdResponse>) => ({});

const useGetTrialMasterGroups = (query?: Partial<GetMasterGroupsByTrialId>, configuration?: SWRConfiguration) => {
    const request = useMemo(() => {
        if (!query) {
            return undefined;
        }

        return () => {
            return new GetMasterGroupsByTrialId(query);
        }
    }, [query]);

    return useGet(request, { getData, getError, getAdditionalState }, configuration);
}

export default useGetTrialMasterGroups;